/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import { connect } from 'react-redux';
import VitalSourceSetup from './VitalSourceSetup';
import {getFrontCoverPageDetails, getFrontCoverThumbnailURL} from "../../../_thunks/cover.thunk";
import {getVitalsourcePublishStatuses, sendVitalsourceInviteEmail, getVitalsourceBookStatuses} from "../../../_thunks/collection.thunk";
import {getVitalsourceCollectionInfo} from "../../../_thunks/vitalsource.thunk";
import { setVitalsourceSubscriptionLength } from "../../../_actions/vitalsource.publish.action";
function mapStateToProps(state, props) {
    return {
        collectionId : state.activeCollection.collectionId,
        coverPageTextInfo: state.frontCover,
        orderDetails: state.orderDetails,
        vitalsourceStatuses: state.vitalsourceStatuses,
        bookdetails: state.bookdetailsreducer,
        subscriptionLength: state.accessCodeSetup.subscriptionLength
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getFrontCoverPage : (collectionId) => {
            dispatch(getFrontCoverThumbnailURL(collectionId, "FrontCoverThumbnail"));
        },
        getvitalsourceStatusLog : (collectionId) => {
            dispatch(getVitalsourcePublishStatuses(collectionId));
            dispatch(getVitalsourceBookStatuses(collectionId));
            dispatch(getVitalsourceCollectionInfo(collectionId));
        },
        sendVitalsourceInviteEmail : (collectionId) => {
            dispatch(sendVitalsourceInviteEmail(collectionId));
        },
        setSubscriptionLength : (length) => {
            dispatch(setVitalsourceSubscriptionLength(length));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(VitalSourceSetup);



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/VitalSourceSetupLink.js